import React,{useEffect} from 'react';
import { BrowserRouter,Switch,Route} from 'react-router-dom';
import {useDispatch} from 'react-redux';

import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Player from './components/Player';
import Matches from './components/Matches/Matches';
import Card from './components/Card';
import Scoreboard from './components/scoreboard/Scoreboard';
import Test from './components/Test.js';
import Jquery from "./components/Jquery";
import {getMatches,getPlayers,getEvents} from './actions/match';


const App = () => {

   const dispatch=useDispatch();

   useEffect(()=>{
      dispatch(getMatches());
      dispatch(getPlayers());
      dispatch(getEvents());
   },[]);

    return (
     <BrowserRouter>
        <Switch>
           <Route path="/" exact component={Login}/>
           <Route path="/register" component={Register}/>
           <Route path="/home" component={Matches}/>
           <Route path="/players" component={Player}/>
           <Route path="/startMatch" component={Card}/>
           <Route path="/scoreBoard" component={Scoreboard}/>
           <Route path="/jquery" component={Jquery} />
           <Route path="/trial" component={Test}></Route>
        </Switch>
     </BrowserRouter>
    )
}

export default App
